import styled from 'styled-components';
import { useEffect, useRef } from 'react';
import { getFile } from '@/api/query/file';
import ImageLoading from './images/image-loading.png';
import ImagePlaceholder from './images/image-placeholder.png';

const ImageMessageContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
`;

const Image = styled.img`
	object-fit: cover;
	width: 70%;
	min-width: 30%;
	max-height: 500px;
	border-radius: 8px;
	margin: 10px 10px 0;

	@media (min-width: 600px) {
		max-width: 30%;
		min-width: 10%;
	}
`;

type Props = { imageId?: string; nsfw?: boolean };

function ImageMessage({ imageId, nsfw }: Readonly<Props>) {
	const wasSet = useRef(false);
	const imageRef = useRef<HTMLImageElement>(null);

	useEffect(() => {
		if (wasSet.current || !imageId) return;

		getFile(imageId).then((file) => {
			wasSet.current = true;
			imageRef.current!.src = file.data;

			const element = document.getElementById(`bottom-info`);
			element?.scrollIntoView({});
		});
	}, []);

	return (
		<ImageMessageContainer>
			<Image src={nsfw ? ImagePlaceholder : ImageLoading} ref={imageRef} />
		</ImageMessageContainer>
	);
}

export default ImageMessage;
